// extracted by mini-css-extract-plugin
export default {"main":"RestaurantsError_main__CLl5e","mainImage":"RestaurantsError_mainImage__wntdO","title":"RestaurantsError_title__dIn0u"};